import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {DELIVERY_METHOD_IDS} from '@stubhub/delivery-utils';
import {connect} from '@stubhub/react-store-provider';

// Controller
import {query} from '../../../../modules/react-query';

import controller from './controller';

export default function BuildYourOrderContainer(InnerComponent) {
  @query({
    quantity: 'qty',
    byoQuantity: 'byo_qty',
    listingId: 'ticket_id',
    priceWithFees: 'priceWithFees',
  })
  @connect(controller)
  class BuildYourOrder extends PureComponent {
    static contextTypes = {
      globalRegistry: PropTypes.object,
    };

    UNSAFE_componentWillMount() {
      const {listingId} = this.props;
      this.BYOFetchListingDetails(listingId);
    }

    componentDidUpdate(prevProps) {
      const {listingId, priceWithFees, fetchSelectedListing, eventId, getQuery} = this.props;
      if (listingId !== prevProps.listingId) {
        this.BYOFetchListingDetails(listingId);
      }
      if (priceWithFees !== prevProps.priceWithFees) {
        fetchSelectedListing(eventId, listingId, {...((getQuery && getQuery(this.props)) || {})});
      }
    }

    componentWillUnmount() {
      const {resetBYOSectionId} = this.props;
      resetBYOSectionId();
    }

    get checkoutQuantity() {
      const {byoQuantity, quantity, listing = {}} = this.props;
      const {splitVector = [1]} = listing;
      let result;

      if (byoQuantity && byoQuantity === quantity) {
        result = byoQuantity;
      } else if (quantity) {
        result = quantity;
      } else {
        [result] = splitVector;
        const [split1, split2] = splitVector;
        if (split1 === 2 || split2 === 2) {
          result = 2;
        }
      }

      return result;
    }

    BYOFetchListingDetails = (listingId) => {
      const {getListingDetail, getQuery} = this.props;
      const retryTimes = 3;

      const query = (getQuery && getQuery(this.props)) || {};

      if (listingId) {
        getListingDetail({listingId: Number(listingId)}, retryTimes, {...query, listingId});
      }
    };

    isDeliveryMethodEligibleForGuestCheckout() {
      const deliveryMethodsNotEligible = [DELIVERY_METHOD_IDS.FLASHSEAT_INSTANT, DELIVERY_METHOD_IDS.FLASHSEAT]; // As referenced in GCG-1126
      const {listingsMap, listingId} = this.props;
      const listingFromMap = listingsMap[listingId];
      let isEligible = true;

      if (listingFromMap) {
        for (let i = 0; i < deliveryMethodsNotEligible.length; i++) {
          if (listingFromMap.deliveryMethodList.includes(deliveryMethodsNotEligible[i])) {
            isEligible = false;
          }
        }
      }

      return isEligible;
    }

    get guestCheckout() {
      const {globalRegistry} = this.context || {};
      if (
        globalRegistry &&
        globalRegistry.getFeatureValue('common.guestXO') &&
        this.isDeliveryMethodEligibleForGuestCheckout()
      ) {
        return '&gxo=1';
      }

      return '';
    }

    render() {
      const {listingId, eventId, byoQuantity} = this.props;

      const checkoutParamsString = `event_id=${eventId}&ticket_id=${listingId}&quantity_selected=${byoQuantity}${this.guestCheckout}`;

      return (
        <InnerComponent {...this.props} quantity={this.checkoutQuantity} checkoutParamsString={checkoutParamsString} />
      );
    }
  }

  BuildYourOrder.propTypes = {
    /**
     * Listing ID
     */
    listingId: PropTypes.number,

    /**
     * Event ID
     */
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
     * Number of tickets selected in listing
     */
    byoQuantity: PropTypes.number,

    /**
     * Price object with amount and currency
     */
    price: PropTypes.object,

    /**
     * Object of listings
     */
    listingsMap: PropTypes.object,

    /**
     * Method to get listing details
     */
    getListingDetail: PropTypes.func.isRequired,
    getQuery: PropTypes.func,

    /**
     * Quantity filter
     */
    quantity: PropTypes.number,

    /**
     * Listing info
     */
    listing: PropTypes.object,

    /**
     * If price includes fees
     */
    priceWithFees: PropTypes.bool,

    /**
     * Method to fetch selected listing info
     */
    fetchSelectedListing: PropTypes.func.isRequired,

    /**
     * Method to reset section ID selected
     */
    resetBYOSectionId: PropTypes.func.isRequired,
  };

  return BuildYourOrder;
}
